import { KeyDescriptionViewModel } from './keyDescriptionViewModel';
import { Decimal } from 'decimal.js';
import { StageViewModel } from './stage-viewmodel';
import { ChargeViewModel } from './chargeViewModel';

export class PcnModel {
  public pcn = '';
  contravention = '';
  offenceSuffixTypeId = '';

  actions: Array<KeyDescriptionViewModel> = [];
  selectedActionId: number;

  sources: Array<KeyDescriptionViewModel> = [];
  selectedSourceId: number;

  stages: Array<StageViewModel> = [];
  selectedStageId: number;

  fineAmounts: Array<ChargeViewModel> = [];
  selectedCharge: ChargeViewModel;
  selectedChargeId = 0;
  selectedFineAmount: Decimal = new Decimal(0);
  paidAmount: Decimal = new Decimal(0);
  fineNow: Decimal = new Decimal(0);
  payment = "0";
  paymentDate: Date = new Date();
  dateIssued: Date = new Date();
  letterDate: Date = new Date();
  decisionId = "";
  registration = "";
  title = "Mr";
  name = "";
  company = "";
  lastName = "";
  location = "";
  address1 = "";
  address2 = "";
  address3 = "";
  address4 = "";
  address5 = "";
  postcode = "";
  reOfferDiscount = true;
  email = '';
  fax = '';
  repId = 0;
  isLondonPolicy = false;
  correspondenceReference = '';
  textResourceGroups: Array<KeyDescriptionViewModel> = [];
  contraventionSuffix = '';

  isInterfaced = false;
  fineNowChanged = false;
}
